export default __webpack_public_path__ + "static/pixel-computer-cd9c85ab6f80a882d14fac742438c566.png";